module.exports = __webpack_public_path__ + "static/media/image-7@2x.14db2895.png";